export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("es-CL", {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
  }).format(value);
};
